module.exports = __webpack_public_path__ + "static/media/shiftshave-3.edf23c5a.jpg";